module.exports = __webpack_public_path__ + "static/img/score-mobile-6.bf40cc57.png";